.loadingScreen {
  min-height: 100vh;
  padding: var(--space-8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: var(--color-background)
}

.dots {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
}

.dot {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: var(--radius-full);
  background-color: var(--color-primary);
  opacity: 0.22;
  animation: dot-pulse 1.35s ease-in-out infinite;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.18s;
}

.dot:nth-child(3) {
  animation-delay: 0.36s;
}

.loadingText {
  max-width: 48rem;
  margin: 0;
  color: var(--color-text-dark);
  font-family: var(--font-family-header);
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-semibold);
}

@keyframes dot-pulse {
  0%,
  100% {
    opacity: 0.22;
    transform: scale(0.82);
  }

  45% {
    opacity: 1;
    transform: scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .dot {
    animation: none;
    opacity: 0.65;
  }
}

@media screen and (max-width: 768px) {
  .loadingScreen {
    padding: var(--space-6);
    gap: var(--space-5);
  }

  .dots {
    gap: var(--space-2);
    padding: var(--space-2) var(--space-3);
  }

  .dot {
    width: 0.5rem;
    height: 0.5rem;
  }

  .loadingText {
    font-size: var(--font-size-xl);
  }
}
